import { createTheme } from '@mui/material/styles';

// assets
import colors from 'assets/scss/_themes-vars.module.scss';

// project imports
import componentStyleOverrides from './compStyleOverride';
import themePalette from './palette';
import themeTypography from './typography';

/**
 * Represent theme style and structure as per Material-UI
 * @param {JsonObject} customization customization parameter object
 */

export const theme = (customization, { active }) => {
    const color = colors;

    const themeOptionLight = {
        mode: 'light',
        colors: color,
        heading: color.grey900,
        paper: color.paper,
        backgroundDefault: color.paper,
        primaryLight: color.primaryLight,
        background: color.primaryLight,
        secondaryLight: color.secondaryLight,
        secondaryDark: color.secondaryDark,
        darkTextPrimary: color.grey700,
        darkTextSecondary: color.grey500,
        textDark: color.grey900,
        secondaryMain: color.secondaryMain,
        menuSelected: color.secondaryDark,
        menuSelectedBack: color.secondaryLight,
        warningLight: color.warningLight,
        divider: color.grey200,
        secondary800: color.secondary800,
        grey100: color.grey100,
        grey500: color.grey500,
        grey5002: color.grey500,
        secondary200: color.secondary200,
        customization,
    };

    const themeOptionDark = {
        mode: 'dark',
        colors: color,
        heading: active.heading,
        paper: active.paper,
        backgroundDefault: active.defaultBg,
        background: active.backGround,
        darkTextPrimary: active.darkTextPrimary,
        primaryLight: active.primaryLight,
        secondaryLight: active.secondaryLight,
        secondaryDark: active.secondaryDark,
        darkTextSecondary: active.darkTextSecondary,
        textDark: active.textDark,
        secondary800: active.secondary800,
        grey999: active.grey999,
        warningLight: active.warningLight,
        secondaryMain: active.secondaryMain,
        grey50: active.grey50,
        secondary200: active.secondary200,
        grey500: active.grey500,
        grey5002: active.grey5002,
        menuSelected: active.menuSelected,
        menuSelectedBack: active.menuSelectedBack,
        divider: active.divider,
        customization,
    };

    const themeOptions = {
        
        direction: 'ltr',
        palette: themePalette(themeOptionDark),
        mixins: {
            toolbar: {
                minHeight: '48px',
                padding: '16px',
                '@media (min-width: 600px)': {
                    minHeight: '48px',
                },
            },
        },
        typography: themeTypography(themeOptionDark),
    };

    const themes = createTheme(themeOptions);
    themes.components = componentStyleOverrides(themeOptionDark);

    return themes;
};

export default theme;
